module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/mouth-050e3c598a5df23f411a11850f7831f7.png";